function safeParse<T = any>(inputString: string): T | null {
  try {
    return inputString ? JSON.parse(inputString) : null;
  } catch (ex) {
    console.error('exception in safeParse', ex); // eslint-ignore-line no-console

    return null;
  }
}

export default safeParse;
